export interface BatchOrderAcceptBreakingNewsRequest {
  acceptanceDateFrom: string
  acceptanceDateTo: string
  branch: string
  collectionType: string
  batchType: string
}

export function BatchOrderAcceptBreakingNewsRequestToJSON(
  value: BatchOrderAcceptBreakingNewsRequest
): any {
  return {
    acceptance_date_from: value.acceptanceDateFrom,
    acceptance_date_to: value.acceptanceDateTo,
    branch: value.branch,
    collection_type: value.collectionType,
    batch_type: value.batchType
  }
}
